import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";
import MobileSettingFormModal from "@/components/modules/account/MobileSettingFormModal.vue";
import NicknameFormModal from "@/components/modules/account/NicknameFormModal.vue";
import ChangePasswordFormModal from "@/components/modules/account/ChangePasswordFormModal.vue";
import { formatDollar } from "@/helpers/formatDollar";
import { ref } from "vue";
import { maskMobile } from "@/helpers/maskMobile";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProfile',
  props: {
    user: null
  },
  setup(__props: any) {

const props = __props as { user: User };


const showMobileSettingModal = ref(false);
const showNicknameModal = ref(false);
const showChangePasswordModal = ref(false);

const { $t } = useTranslation();


function formatBoolean(bool: boolean) {
  return bool ? "Yes" : "No";
}

return { __sfc: true,props, showMobileSettingModal, showNicknameModal, showChangePasswordModal, $t, formatBoolean, MobileSettingFormModal, NicknameFormModal, ChangePasswordFormModal, formatDollar, maskMobile }
}

})